import { render, staticRenderFns } from "./IndexUseNetDepletionStat.vue?vue&type=template&id=944ec6a4&scoped=true&"
import script from "./IndexUseNetDepletionStat.vue?vue&type=script&lang=js&"
export * from "./IndexUseNetDepletionStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944ec6a4",
  null
  
)

export default component.exports